module.exports = __webpack_public_path__ + "img/eliza.a55e6114.png";